import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgChatDots = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.625 2.62502C11.0657 2.62277 9.53414 3.03786 8.18936 3.82722C6.84457 4.61657 5.73554 5.75143 4.97733 7.11402C4.21913 8.47662 3.83939 10.0173 3.87751 11.5762C3.91564 13.135 4.37025 14.6553 5.19417 15.9792L2.625 21.375L8.02 18.805C9.17056 19.5207 10.4716 19.9593 11.8206 20.0864C13.1696 20.2135 14.5297 20.0256 15.7936 19.5375C17.0576 19.0493 18.191 18.2743 19.1044 17.2735C20.0178 16.2727 20.6863 15.0734 21.0572 13.7702C21.4281 12.467 21.4913 11.0955 21.2418 9.76367C20.9922 8.43188 20.4368 7.17623 19.6193 6.09568C18.8018 5.01513 17.7445 4.1392 16.5308 3.53692C15.317 2.93464 13.98 2.62248 12.625 2.62502V2.62502Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 11.0625C8.81319 11.0625 8.75277 11.0808 8.70138 11.1152C8.64999 11.1495 8.60994 11.1983 8.58629 11.2554C8.56264 11.3125 8.55645 11.3753 8.5685 11.436C8.58056 11.4966 8.61033 11.5523 8.65403 11.596C8.69773 11.6397 8.75342 11.6694 8.81403 11.6815C8.87465 11.6936 8.93749 11.6874 8.99459 11.6637C9.05169 11.6401 9.1005 11.6 9.13483 11.5486C9.16917 11.4972 9.1875 11.4368 9.1875 11.375C9.1875 11.2921 9.15458 11.2126 9.09597 11.154C9.03737 11.0954 8.95788 11.0625 8.875 11.0625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 11.0625C12.5632 11.0625 12.5028 11.0808 12.4514 11.1152C12.4 11.1495 12.3599 11.1983 12.3363 11.2554C12.3126 11.3125 12.3064 11.3753 12.3185 11.436C12.3306 11.4966 12.3603 11.5523 12.404 11.596C12.4477 11.6397 12.5034 11.6694 12.564 11.6815C12.6247 11.6936 12.6875 11.6874 12.7446 11.6637C12.8017 11.6401 12.8505 11.6 12.8848 11.5486C12.9192 11.4972 12.9375 11.4368 12.9375 11.375C12.9375 11.2921 12.9046 11.2126 12.846 11.154C12.7874 11.0954 12.7079 11.0625 12.625 11.0625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 11.0625C16.3132 11.0625 16.2528 11.0808 16.2014 11.1152C16.15 11.1495 16.1099 11.1983 16.0863 11.2554C16.0626 11.3125 16.0564 11.3753 16.0685 11.436C16.0806 11.4966 16.1103 11.5523 16.154 11.596C16.1977 11.6397 16.2534 11.6694 16.314 11.6815C16.3747 11.6936 16.4375 11.6874 16.4946 11.6637C16.5517 11.6401 16.6005 11.6 16.6348 11.5486C16.6692 11.4972 16.6875 11.4368 16.6875 11.375C16.6875 11.2921 16.6546 11.2126 16.596 11.154C16.5374 11.0954 16.4579 11.0625 16.375 11.0625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgChatDots.displayName = 'SvgChatDots';
export default SvgChatDots;
